import React from 'react';
import { socialLinks } from './SocialIcons.constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

export const SocialIcons = () => {
	return (
		<div className='socialContainer'>
			<ul>
				{socialLinks.map(({ name, link }) => {
					return (
						<div className="socialitemdiv">
							<a href={link} target="_blank" rel="noreferrer">
								<FontAwesomeIcon icon={name} size="lg" className="highlight"/>
							</a>
						</div>
					);
				})}
			</ul>
		</div>
	);
};
